//  in the live hunt version of this puzzle, the client source code was obfuscated 
//    and the border detector was hidden server side.

//  in this static version, all code is client side and in plain view -
//    if you are trying to solve this puzzle, please try without looking in the source!

// functions for computing shape at the draw client


import * as neataptic from 'neataptic'
import {drawingToArray, normalize} from '@/assets/draw/convert.js'
import json from '@/assets/draw/network-fancy1.json'

let network = neataptic.Network.fromJSON(json);

export function classify(drawing) {

  let arr = drawingToArray(normalize(drawing));

  // cheap way if network is not yet loaded, just classify as squiggle
  if (typeof network === 'undefined') return [0, 0, 0, 1]

  return network.activate(arr);
}